var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoIdeeri(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 337.633,
    height: 308.829,
    viewBox: "0 0 337.633 308.829",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #ecbc00;\n      }\n\n      .cls-2, .cls-3 {\n        fill: #fff;\n      }\n\n      .cls-3 {\n        opacity: 0.52;\n      }\n\n      .cls-4 {\n        font-size: 10px;\n        font-family: ArialMT, Arial;\n      }\n\n      .cls-5 {\n        fill: #21341c;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "FOND_Blanc",
    "data-name": "FOND Blanc",
    transform: "translate(168.816 154.415)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_12",
    "data-name": "Groupe 12",
    transform: "translate(-168.816 -154.415)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_13",
    "data-name": "Ellipse 13",
    className: "cls-1",
    cx: 154.415,
    cy: 154.415,
    rx: 154.415,
    ry: 154.415,
    transform: "translate(28.803)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_38",
    "data-name": "Trac\\xE9 38",
    className: "cls-2",
    d: "M286.954,405.215C231.043,363.791,154.4,327.235,85.7,357.354,36.233,379.376-16.786,460.46,5.057,514.8c17.779,41.246,66.658,55.214,107.672,56.672,33.122.63,68.243-8.363,87.951-37.22,17.865-23.826,27.144-52.542,38.5-79.775,8.531-18.582,16.978-45,40.1-48.259C281.473,405.518,288.08,407.659,286.954,405.215Z",
    transform: "translate(0 -291.511)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_39",
    "data-name": "Trac\\xE9 39",
    className: "cls-3",
    d: "M387.91,478C332,436.573,255.353,400.018,186.652,430.136,137.189,452.158,84.17,533.242,106.013,587.583c17.779,41.246,66.658,55.214,107.672,56.672,33.122.63,68.243-8.363,87.95-37.22,17.865-23.826,27.144-52.542,38.5-79.775,8.531-18.582,16.978-45,40.1-48.259C382.43,478.3,389.036,480.441,387.91,478Z",
    transform: "translate(-84.985 -352.779)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(62.55 114.742)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_40",
    "data-name": "Trac\\xE9 40",
    className: "cls-5",
    d: "M768.718,792.885H755.041l-.394-2.98c-11.537,5.959-22.4,5.714-32.3-3.422-7.463,7.547-16.426,8.931-26.182,6.008a19.622,19.622,0,0,1-14.016-18.358,44.612,44.612,0,0,1,1.286-12.46c2.059-7.586,7.415-12.055,15.188-13.395,8.219-1.416,15.522.092,20.955,7.052.385.493.761.993,1.346,1.756a20.015,20.015,0,0,1,16.1-9.222c6.6-.473,12.5,1.149,17.614,6.4.13-2.109.229-3.721.341-5.537H767.71l.671,4.931c3.6-4.881,7.8-7,13.241-5.331v12.615c-2.372,0-4.469-.139-6.542.029-4.466.361-6.358,2.479-6.361,6.876q-.007,10.75,0,21.5C768.718,790.468,768.718,791.593,768.718,792.885Zm-36.712-17.614c2.024,8.814,11.074,10.305,20.256,3.234l1.858,3.063.53-.394v-5.9Zm-15.79,3.27,3.116,3.933c-1.349-7.373-1.349-7.373-7.538-7.373h-15.5c.553,3.845,2.432,6.192,5.465,7.241C707.121,784.2,711.873,782.761,716.216,778.541Zm15.823-12.068c3.524,0,6.849.007,10.173,0,3.62-.01,4.524-1.345,2.747-4.506a7.271,7.271,0,0,0-3.161-2.826C738.041,757.427,732.551,759.224,732.04,766.472Zm-22.345-.209c.4-4.814-1.688-7.423-5.927-7.727-4.142-.3-7.029,2.7-7.261,7.727Z",
    transform: "translate(-574.219 -629.465)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_41",
    "data-name": "Trac\\xE9 41",
    className: "cls-5",
    d: "M446.1,699.841a88.142,88.142,0,0,1-10.559-.158c-1.029-.126-1.827-2.134-2.453-2.928-2.967,1.215-6.084,3.28-9.406,3.694-7.739.963-13.818-3.274-16.486-10.891a35.938,35.938,0,0,1-.391-22.984c2.837-9.116,10.866-13.818,19.286-11.414,2.142.611,4.068,1.978,6.5,3.2,0-3.611,0-7.13,0-10.649,0-3.465,0-6.931,0-10.672H446.1Zm-13.512-22.148c0-2.1-.084-4.207.02-6.3.149-3.011-1.419-4.69-4.071-5.6-2.907-1-5.415-.394-7.276,2.114-2.893,3.9-2.972,15.4-.121,19.407,1.822,2.562,4.384,3.128,7.265,2.184,2.607-.854,4.345-2.439,4.2-5.5C432.505,681.9,432.585,679.794,432.585,677.692Z",
    transform: "translate(-341.019 -536.26)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_42",
    "data-name": "Trac\\xE9 42",
    className: "cls-5",
    d: "M294.284,716.817V657.485H308.31v59.332Z",
    transform: "translate(-247.728 -553.471)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_43",
    "data-name": "Trac\\xE9 43",
    className: "cls-5",
    d: "M1335.717,803.567h-13.46v-43.12h13.46Z",
    transform: "translate(-1113.076 -640.144)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_14",
    "data-name": "Ellipse 14",
    className: "cls-5",
    cx: 8.92,
    cy: 8.92,
    rx: 8.92,
    ry: 8.92,
    transform: "translate(206.991 94.306)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIdeeri);
export default __webpack_public_path__ + "static/media/logo_Ideeri.32296f9b49fa562a9f6eff5c0aa442bc.svg";
export { ForwardRef as ReactComponent };